import focusWithin from './_focus-within';

export default class {
	constructor(form) {
		this.form = form;
		this.fieldHasValueClass = 'gfield--has-value';
		this.labelHasValueClass = 'gfield_label--has-value';

		focusWithin( this.form.querySelectorAll('.gfield') );

		const getLabel = (node) => {
			if ( node.id ) {
				let label = this.form.querySelector(`label[for="${node.id}"]`);

				if ( label ) {
					return label;
				}
			}

			while( node && node.parentNode ) {
				if ( node.tagName === 'LABEL' ) {
					return node;
				}

				node = node.parentNode;
			}

			return null;
		}

		const onchange = (e, hasValueTarget = null) => {
			let node = e.target;

			hasValueTarget = hasValueTarget ? hasValueTarget : getLabel(e.target);

			if ( hasValueTarget ) {
				if ( node.value ) {
					hasValueTarget.classList.add(this.labelHasValueClass);
				} else {
					hasValueTarget.classList.remove(this.labelHasValueClass);
				}
			}

			while( node && node !== this.form ) {
				// set a class on the field
				if ( node.classList.contains( 'gfield' ) ) {
					if ( e.target.value ) {
						node.classList.add(this.fieldHasValueClass);
					} else {
						node.classList.remove(this.fieldHasValueClass);
					}
				}

				node = node.parentNode;
			}
		}

		Array.from(this.form.elements).forEach( node => {
			let label = getLabel(node);
			if ( label && ! node.placeholder ) {
				node.placeholder = label.textContent;
			}

			node.addEventListener( 'input', (e) => {
				onchange(e);
			} );
			onchange( { target: node } );
		} );

		Array.from( this.form.querySelectorAll('.ginput_container_address input, .ginput_container_address select') ).forEach( node => {
			let parent = node.parentNode;
			node.addEventListener('input', (e) => {
				onchange(e, parent);
			});
			onchange( { target: node }, parent );
		} );
	}
}
